import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './LuckyWheelDetail.less';

export default class luckyWheelDetail extends OfficialPage {
  state = {
    topNavBarData: {
      title: '参与活动赢大奖',
      isDefault: 0
    },
    activityId: '',
    activityData: {}, //
    winnerList: [], //中奖名单
    recordSick: 0, //我的奖品弹窗是否显示
    animationData: {}, //圆盘动画
    awardsList: {}, //奖项列表
    opportunities: '', //抽奖机会次数
    text: 'Page animation',
    congratulation: 0, //中奖弹窗是否显示
    prizeTitle: '', //奖品名称
    prizeFail: 0, //未中奖弹窗是否显示
    colorAwardDefault: '#FE7F3A', //奖品默认颜色
    colorAwardSelect: 'rgba(255,113,0,.5)', //奖品选中颜色
    indexSelect: '', //被选中的奖品index
    isRunning: false, //是否正在抽奖
    runDegs: 0,
    duraMax: 0, //抽奖次数弹窗是否显示
    comfort: 0, //安慰奖弹窗
    isPlay: false,
    isExchange: 0, //兑换次数弹窗
    exchangeMessage: {}, //兑换次数数据
    chanageMes: '',
    inputValue: '',
    isdegree: 0, //次数用尽不可分享好有弹窗
    RecordSickArr: [],
    winListData: {},
    winListData2: {},
    franchisee: '',
    ifWxCoupon: false,
    timestamp: '',
    signature: '',
    ifGetComfort: false,
    isShare: false
  }

  constructor(props) {
    super(props);
    document.title = '大转盘';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let that = this
    let id = that.data.activityData.id
    let franchisee = options.franchisee || ''
    this.setData({
      franchisee: franchisee,
      shareKey: options.shareKey || '',
      'topNavBarData.topNavBarHeight': app.globalData.topNavBarHeight || 0
    })
    if (app.isLogin()) {
      that.dataInitial()
    } else {
      app.goLogin({
        success: function () {
          that.dataInitial()
        },
        fail: function () {
          app.turnBack()
        }
      })
    }
    this.animation = app.createAnimation({
      duration: 0,
      timingFunction: 'step-start'
    })
    this.animation2 = app.createAnimation({
      duration: 0,
      timingFunction: 'step-start'
    })
  }

  componentWillUnmount() {
    let that = this
    clearTimeout(that.timeer)
    clearTimeout(that.timeer2)
    clearTimeout(that.timeer3)
    clearTimeout(that.timeer4)
  }

  getShareKey = id => {
    var that = this,
      dataObj = new Object()
    dataObj['activity_id'] = id
    if (that.data.franchisee) {
      dataObj['sub_app_id'] = that.data.franchisee
    }
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getShareKey',
      data: dataObj,
      success: function (res) {
        var data = res
        if (data.status == 0) {
          that.setData({
            shareKey: data.data
          })
        }
      }
    })
  }
  getTimeByShareKey = (id, shareKey) => {
    var that = this,
      dataObj = new Object()
    dataObj['activity_id'] = id
    dataObj['share_key'] = shareKey
    if (that.data.franchisee) {
      dataObj['sub_app_id'] = that.data.franchisee
    }
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTimeByShareKey',
      data: dataObj,
      success: function (res) { }
    })
  }
  getWinnerList = id => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getWinnerList',
      method: 'post',
      data: {
        activity_id: id,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        let winHeight = (res.count + 5) * 44
        that.setData({
          winnerList: res.data
        })
        that.animationTop(winHeight, true)
      }
    })
  }
  animation = ''
  animation2 = ''
  animationTop = (h, isreset) => {
    var that = this
    var $winconList1 = document.querySelector('.winconList1');
    clearTimeout(that.timeer)
    clearTimeout(that.timeer2)
    if (isreset) {
      // that.animation
      //   .top({start: '1.9rem'})
      //   .step({ duration: 0, timingFunction: 'step-start' })
      // that.animation2
      //   .top({start: '1.9rem'})
      //   .step({ duration: 0, timingFunction: 'step-start' })
      // that.setData({
      //   winListData: that.animation.export(),
      //   winListData2: that.animation2.export()
      // })
      setTimeout(function () {
        that.animation
          .top({start:'1.9rem', end: '-' + (h / 100) + 'rem'})
          .step({ duration: 15000, timingFunction: 'linear' })
        $winconList1.animate(that.animation.keyframes, that.animation.options);
        // that.setData({
        //   winListData: that.animation.export()
        // })
        that.animationTopCopy(h, isreset)
      }, 50)
    } else {
      that.timeer = setTimeout(function () {
        // that.animation
        //   .top({start: '1.9rem'})
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.setData({
        //   winListData: that.animation.export()
        // })
      }, (200 / (h + 200)) * 15000)
      that.timeer2 = setTimeout(function () {
        that.animation
          .top({start: '1.9rem', end: '-' + (h / 100) + 'rem'})
          .step({ duration: 15000, timingFunction: 'linear' })
        $winconList1.animate(that.animation.keyframes, that.animation.options);
        // that.setData({
        //   winListData: that.animation.export()
        // })
        that.animationTopCopy(h)
      }, (h / (h + 200)) * 15000)
    }
  }
  animationTopCopy = (h, isreset) => {
    var that = this
    var $winconList2 = document.querySelector('.winconList2');
    clearTimeout(that.timeer3)
    clearTimeout(that.timeer4)
    if (!isreset) {
      that.timeer3 = setTimeout(function () {
        // that.animation2
        //   .top({start: '1.9rem'})
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.setData({
        //   winListData2: that.animation2.export()
        // })
      }, (200 / (h + 200)) * 15000)
    }
    that.timeer4 = setTimeout(function () {
      that.animation2
        .top({start: '1.9rem', end: '-' + (h / 100) + 'rem'})
        .step({ duration: 15000, timingFunction: 'linear' })
      $winconList2.animate(that.animation2.keyframes, that.animation2.options)
      // that.setData({
      //   winListData2: that.animation2.export()
      // })
      that.animationTop(h)
    }, (h / (h + 200)) * 15000)
  }
  clickpagePrize = () => {
    let that = this
    that.setData({ recordSick: 1 })
    that.getMyPrize()
  }
  clickRecordSick = e => {
    this.setData({ recordSick: 0 })
  }
  stopPropagation = () => { }
  confirmClick = () => {
    this.setData({ congratulation: 0 })
  }
  dataInitial = () => {
    var that = this,
      dataObj = new Object()
    dataObj['category'] = 0
    if (that.data.franchisee) {
      dataObj['sub_app_id'] = that.data.franchisee
    }
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getActivity',
      method: 'post',
      data: dataObj,
      success: function (res) {
        var mes = res.data
        // TODO
        // that.audioCtx = app.createAudioContext('luckyAudio')
        // if (mes.bgm != 0) {
        //   that.audioCtx.play()
        // } else {
        //   that.audioCtx.pause()
        // }
        mes.description = mes.description.replace(/\\n/g, '\n')
        that.setData({
          activityData: mes,
          opportunities: mes.times
        })
        app.setNavigationBarTitle({
          title: res.data.title
        })
        that.getWinnerList(that.data.activityData.id)
        if (that.data.shareKey) {
          that.getTimeByShareKey(that.data.activityData.id, that.data.shareKey)
        }
        that.getShareKey(that.data.activityData.id)
      }
    })
  }
  getLottery = winId => {
    let that = this
    let awardsConfig = that.data.activityData.turntable
    let runNum = 8
    let awardIndex = 0
    if (winId.turntable_id == -1) {
      awardIndex = that.getNotWinIndex()
    } else {
      awardIndex = that.drawClick(winId.turntable_id)
    }
    let runDegs = that.data.runDegs
    let startDegs = runDegs;
    runDegs =
      runDegs - (runDegs % 360) + (360 * runNum - awardIndex * (360 / 8) - 22.5)
    var animationRun = app.createAnimation({
      duration: 4000,
      timingFunction: 'ease'
    })
    var $animationWrap = document.querySelector('#animationWrap');
    that.animationRun = animationRun
    animationRun.rotate({start: startDegs, end: runDegs, dom: $animationWrap}).step();
    $animationWrap.animate(animationRun.keyframes, animationRun.options);
    that.setData({
      // animationData: animationRun.export(),
      opportunities: that.data.opportunities - 1,
      runDegs: runDegs
    })
    setTimeout(function () {
      let title = awardsConfig[awardIndex].prize_title
      if (winId.is_comfort == 1) {
        that.setData({
          comfort: 1,
          isRunning: false,
          ifWxCoupon: winId.card_id || false,
          timestamp: winId.timestamp || '',
          signature: winId.signature || ''
        })
        if (winId.card_id) {
          that.toAddCard()
        } else {
          that.getWinnerList(that.data.activityData.id)
        }
      } else {
        if (title == '谢谢参与') {
          that.setData({
            prizeFail: 1,
            isRunning: false
          })
        } else {
          that.setData({
            congratulation: 1,
            prize_title: title,
            isRunning: false,
            ifWxCoupon: winId.card_id || false,
            timestamp: winId.timestamp || '',
            signature: winId.signature || ''
          })
          if (winId.card_id) {
            that.toAddCard()
          } else {
            that.getWinnerList(that.data.activityData.id)
          }
        }
      }
    }, 5000)
  }
  notwinningClick = () => {
    this.setData({
      prizeFail: 0
    })
  }
  tipClick = () => {
    let that = this
    if (!that.data.activityData.id) {
      return
    }
    if (that.data.opportunities <= 0) {
      if (that.data.activityData.time_share == 0) {
        that.setData({
          isdegree: 1
        })
      } else {
        that.setData({
          duraMax: 1
        })
      }
      return
    }
    if (that.data.isRunning) {
      return
    }
    that.setData({
      isRunning: true
    })
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/lottery',
      method: 'post',
      data: {
        activity_id: that.data.activityData.id,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        if (that.data.activityData.category == 0) {
          that.getLottery(res.data)
        } else {
          that.startGame(res.data)
        }
      },
      successStatusAbnormal: function () {
        that.setData({
          isRunning: false
        })
      }
    })
  }
  startGame = winId => {
    var _this = this
    var indexSelect = _this.data.indexSelect
    var i = 0
    let awardIndex = 0
    if (winId.turntable_id == -1) {
      awardIndex = _this.getNotWinIndex()
    } else {
      awardIndex = _this.drawClick(winId.turntable_id)
    }
    var num = awardIndex + 24 - indexSelect
    _this.setData({
      opportunities: _this.data.opportunities - 1
    })
    var timer = setInterval(function () {
      indexSelect++
      i += 1
      if (i > num) {
        clearInterval(timer)
        if (winId.is_comfort == 1) {
          _this.setData({
            comfort: 1,
            isRunning: false,
            ifWxCoupon: winId.card_id || false,
            timestamp: winId.timestamp || '',
            signature: winId.signature || ''
          })
          if (winId.card_id) {
            _this.toAddCard()
          } else {
            _this.getWinnerList(_this.data.activityData.id)
          }
        } else {
          if (
            _this.data.activityData.turntable[_this.data.indexSelect]
              .prize_title == '谢谢参与'
          ) {
            _this.setData({
              prizeFail: 1,
              isRunning: false
            })
          } else {
            let ifWxCoupon = winId.card_id || false
            _this.setData({
              congratulation: 1,
              prize_title:
                _this.data.activityData.turntable[_this.data.indexSelect]
                  .prize_title,
              isRunning: false,
              ifWxCoupon: ifWxCoupon,
              timestamp: winId.timestamp || '',
              signature: winId.signature || ''
            })
            if (ifWxCoupon) {
              _this.toAddCard()
            } else {
              _this.getWinnerList(_this.data.activityData.id)
            }
          }
        }
        return
      }
      indexSelect = indexSelect % 8
      _this.setData({
        indexSelect: indexSelect
      })
    }, 100)
  }
  drawClick = winId => {
    let that = this,
      list = that.data.activityData.turntable,
      idx = 0
    for (let i = 0; i < list.length; i++) {
      if (list[i].id == winId) {
        idx = i
      }
    }
    return idx
  }
  getNotWinIndex = () => {
    let that = this,
      list = that.data.activityData.turntable,
      idx = 0
    for (let i = 0; i < list.length; i++) {
      if (list[i].coupon_id == -1) {
        idx = i
      }
    }
    return idx
  }
  playMusics = () => {
    if (this.data.activityData.bgm) {
      if (this.data.isPlay) {
        this.audioCtx.pause()
      } else {
        this.audioCtx.play()
      }
    } else {
      app.showToast({
        title: '活动未开始，没有音乐',
        icon: 'none'
      })
    }
  }
  audioPlay = () => {
    this.setData({
      isPlay: true
    })
  }
  audioPause = () => {
    this.setData({
      isPlay: false
    })
  }
  onShareAppMessage = res => {
    this.setData({
      isShare: true
    })
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    var that = this
    return app.shareAppMessage({
      title: that.data.activityData.title,
      path:
        '/awardManagement/pages/luckyWheelDetail/luckyWheelDetail?id=' +
        this.data.activityId +
        '&shareKey=' +
        that.data.shareKey +
        franchiseeParam,
      success: function (res) {
        if (that.data.ifWxCoupon) {
          return
        }
        that.setData({
          prizeFail: 0,
          duraMax: 0,
          congratulation: 0
        })
      },
      fail: function (res) { },
      complete: function () {
        that.setData({
          isShare: false
        })
      }
    })
  }
  sureClick = () => {
    this.setData({
      duraMax: 0
    })
  }
  comfortClick = () => {
    this.setData({
      comfort: 0,
      ifGetComfort: false
    })
  }
  exchangeCancel = () => {
    this.setData({
      isExchange: 0
    })
  }
  exchangePrize = () => {
    this.getMyIntegral()
  }
  getMyIntegral = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getMyIntegralExchangeTimes',
      method: 'post',
      data: {
        activity_id: that.data.activityData.id,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.setData({
          isExchange: 1,
          exchangeMessage: res.data
        })
      }
    })
  }
  degreeClick = () => {
    this.setData({
      isdegree: 0
    })
  }
  exchangeAll = () => {
    let that = this
    that.setData({
      inputValue: that.data.exchangeMessage.exchange_times
    })
  }
  bindReplaceInput = e => {
    this.setData({
      inputValue: e.target.value
    })
  }
  exchangeConfirm = () => {
    let that = this
    that.getTime()
  }
  getTime = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTime',
      method: 'post',
      data: {
        activity_id: that.data.activityData.id,
        type: 'integral',
        times: that.data.inputValue,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.setData({
          opportunities: res.data, //抽奖机会次数
          isExchange: 0,
          inputValue: ''
        })
      }
    })
  }
  getMyPrize = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getMyPrize',
      method: 'post',
      data: {
        activity_id: that.data.activityData.id,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.setData({
          RecordSickArr: res.data
        })
      }
    })
  }
  toAddCard = () => {
    let _data = this.data,
      wxcouponId = _data.ifWxCoupon,
      _this = this
    app.addCard({
      cardList: [
        {
          cardId: wxcouponId,
          cardExt:
            '{"nonce_str":"' +
            _data.timestamp +
            '","timestamp":"' +
            _data.timestamp +
            '", "signature":"' +
            _data.signature +
            '"}'
        }
      ],
      success: function (res) {
        _this.setData({
          ifWxCoupon: false,
          ifGetComfort: true
        })
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
          data: {
            card_id: res.cardList[0].cardId,
            sub_app_id: _data.franchisee,
            activity_id: _data.activityData.id,
            app_id: _data.activityData.app_id
          },
          success: function (res) {
            app.showModal({
              title: '提示',
              content: '领取卡券成功',
              showCancel: false
            })
            _this.getWinnerList(_this.data.activityData.id)
          }
        })
      }
    })
  }
  shadeClose = () => {
    if (this.data.isShare) {
      return
    }
    let _this = this,
      ifWxCoupon = _this.data.ifWxCoupon
    if (ifWxCoupon) {
      app.showModal({
        title: '提示',
        content:
          '微信优惠券不领取到卡包，下次就不能再领取了哦，确定放弃优惠么？',
        showCancel: true,
        confirm: function (res) {
          _this.setData({
            congratulation: 0,
            comfort: 0,
            ifWxCoupon: false,
            ifGetComfort: false
          })
        }
      })
    } else {
      this.setData({
        congratulation: 0,
        comfort: 0,
        ifGetComfort: false
      })
    }
  }

  render() {
    const {
      showGetUserInfo,
      topNavBarData,
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      activityData,
      isPlay,
      goldenData,
      opportunities,
      indexSelect,
      colorAwardSelect,
      colorAwardDefault,
      animationData,
      winnerList,
      winListData,
      winListData2,
      duraMax,
      isdegree,
      prize_title,
      ifWxCoupon,
      congratulation,
      RecordSickArr,
      recordSick,
      ifGetComfort,
      comfort,
      exchangeMessage,
      inputValue,
      isExchange,
      prizeFail
    } = this.state
    return (
      <React.Fragment>
        <div className="official-page lucky-wheel-detail">
          <TopNav title="大转盘" />
          <div className="luckyWheelDetail page" id="luckyWheelDetail">
            <img
              className="lucky-cantaniner"
              style={convertLineStyleData(
                topNavBarData.topNavBarHeight
                  ? 'top:' + topNavBarData.topNavBarHeight + 'px'
                  : ''
              )}
              src={
                activityData.background ||
                'http://cdn.jisuapp.cn/static/webapp/images/phone-container.png'
              }
            />
            {activityData.bgm != 0 && (
              <div
                className={'pageMusic ' + (isPlay == true ? 'active' : '')}
                onClick={this.playMusics}
                style={convertLineStyleData(
                  topNavBarData.topNavBarHeight
                    ? 'top:' + (topNavBarData.topNavBarHeight + 8) + 'px'
                    : ''
                )}
              >
                {isPlay == true && (
                  <span className="ico-moon icon-luckyMusic"></span>
                )}
                {isPlay == false && (
                  <span className="ico-moon icon-luckyMute"></span>
                )}
                {goldenData && goldenData.bgm != 0 && (
                  <Audio
                    id="luckyAudio"
                    src={activityData.bgm}
                    onPlay={this.audioPlay}
                    onPause={this.audioPause}
                    loop
                  ></Audio>
                )}
              </div>
            )}
            <div className="lucky-wheel-content">
              {activityData.category == '1' ? (
                <div className="motive-square">
                  <img src="http://cdn.jisuapp.cn/static/webapp/images/phone-surprise.png" />
                </div>
              ) : (
                  <div className="motive">
                    <img src="http://cdn.jisuapp.cn/static/webapp/images/phone-motive.png" />
                  </div>
                )}
              <div
                className="wholeDiv"
                style={convertLineStyleData(
                  'background:' +
                  (activityData.category == 1
                    ? 'rgba(97, 65, 116, 0.6)'
                    : 'rgba(243,190,30,.3)')
                )}
              >
                <div
                  className="todayChance"
                  style={convertLineStyleData(
                    'color:' + (activityData.category == 1 ? '#fff' : '#6b3600')
                  )}
                >
                  你今日还剩
                  <label
                    style={convertLineStyleData(
                      'color:' +
                      (activityData.category == 1 ? '#fed932' : '#ff090f')
                    )}
                  >
                    {opportunities}
                  </label>
                  次抽奖机会
                </div>
                <div
                  className="personNum"
                  style={convertLineStyleData(
                    'color:' +
                    (activityData.category == 1 ? '#fff' : '#6b3600') +
                    ';display:' +
                    (activityData.joined_show == '-1' ? 'none' : 'inline-block')
                  )}
                >
                  ,共有
                  <label
                    style={convertLineStyleData(
                      'color:' +
                      (activityData.category == 1 ? '#fed932' : '#ff090f')
                    )}
                  >
                    {activityData.joined_show}
                  </label>
                  人参加活动
                </div>
              </div>
              {activityData.category == '1' ? (
                <div id="plateDiv">
                  <img
                    id="plate_img"
                    src="http://cdn.jisuapp.cn/static/webapp/images/startSquare.png"
                    onClick={this.tipClick}
                  />
                  <div className="plate-cont">
                    <img src="http://cdn.jisuapp.cn/static/webapp/images/phone-square.gif" />
                    {activityData.turntable.map((item, groupindex) => {
                      return (
                        <div
                          className={'zf zf' + groupindex}
                          data-id={item.id}
                          style={convertLineStyleData(
                            'background-color:' +
                            (groupindex === indexSelect
                              ? colorAwardSelect
                              : colorAwardDefault) +
                            ';'
                          )}
                          key={groupindex}
                        >
                          <img src={item.prize_logo} />
                          <div>{item.prize_title}</div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              ) : (
                  <div id="outDiv">
                    <img
                      id="tip"
                      src="http://cdn.jisuapp.cn/static/webapp/images/phone-start.png"
                      onClick={this.tipClick}
                      data-id={activityData.id}
                    />
                    <div className="outer-cont" id="animationWrap">
                      <img
                        className="img"
                        src="http://cdn.jisuapp.cn/static/webapp/images/phone-wheel.gif"
                      />
                      {activityData.turntable && activityData.turntable.map((item, groupindex) => {
                        return (
                          <div
                            className={'zp zp' + groupindex}
                            data-id={item.id}
                            key={item.id}
                          >
                            <label>{item.prize_title}</label>
                            <img src={item.prize_logo} />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )}
              <div className="structurePrize">
                <div className="lookPrize" onClick={this.clickpagePrize}>
                  查看奖品
                </div>
                <div
                  className="exchangePrize"
                  style={convertLineStyleData(
                    'display:' +
                    (activityData.integral_exchange == 0
                      ? 'none'
                      : 'inline-block')
                  )}
                  onClick={this.exchangePrize}
                >
                  积分兑换
                </div>
              </div>
              <div className="winList">
                <div className="wintitle">中奖名单</div>
                <div
                  className="winCon"
                  style={convertLineStyleData(
                    'background:' +
                    (activityData.category == 1 ? '#6b4780' : '#AE2C53')
                  )}
                >
                  {winnerList.length === 0 ? (
                    <div className="no-winner-list">暂无中奖名单</div>
                  ) : (
                      <React.Fragment>
                        <div className="winconList winconList1" animation={winListData}>
                          {winnerList.map((item, index) => {
                            return (
                              <div key={index}>
                                {item.nickname + '抽中' + item.prize_title}
                              </div>
                            )
                          })}
                        </div>
                        <div className="winconList winconList2" animation={winListData2}>
                          {winnerList.map((item, index) => {
                            return (
                              <div key={index}>
                                {item.nickname + '抽中' + item.prize_title}
                              </div>
                            )
                          })}
                        </div>
                      </React.Fragment>
                    )}
                </div>
              </div>
              <div className="active-rule">
                <div className="active-rule-title">活动规则</div>
                <div
                  className="strip-content"
                  style={convertLineStyleData(
                    'background:' +
                    (activityData.category == 1 ? '#6b4780' : '#AE2C53')
                  )}
                >
                  <div className="strip-time">
                    <label>活动时间：</label>
                    <label className="specific-time">
                      {activityData.start_time}-{activityData.end_time}
                    </label>
                  </div>
                  <div className="textValue" style={convertLineStyleData('word-break:break-all;')}>
                    <span>{activityData.description}</span>
                  </div>
                  {activityData.user_times_initial > 0 && (
                    <div className="prizedTotalBox">
                      <label className="prizeDisc">·</label>用户每日首次登录可获取
                      <label>{activityData.user_times_initial}</label>次抽奖机会
                    </div>
                  )}
                  <div className="drawTotalTimes">
                    <label className="prizeDisc">·</label>每日抽奖机会最多为
                    <label>
                      {activityData.user_times == '-1'
                        ? '无数'
                        : activityData.user_times}
                    </label>
                    次
                  </div>
                  {activityData.integral_exchange != '0' && (
                    <div className="exchangeTimes">
                      <label className="prizeDisc">·</label>每
                      <label>
                        {activityData.integral_exchange == '0'
                          ? '0'
                          : activityData.integral_exchange}
                      </label>
                      积分可兑换一次抽奖机会
                    </div>
                  )}
                  {activityData.time_share != '0' && (
                    <div className="sharesTimes">
                      <label className="prizeDisc">·</label>
                      每成功分享1个好友可增加
                      <label>
                        {activityData.time_share == '0'
                          ? '0'
                          : activityData.time_share}
                      </label>
                      次抽奖机会，最多可增加
                      <label>
                        {activityData.time_share_limit == '0'
                          ? '0'
                          : activityData.time_share_limit}
                      </label>
                      次机会
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* 抽奖次数用完可以分享给好友弹窗 */}
            {duraMax == 1 && (
              <div className="duraMaxDiv">
                <div className="duraMaxDiv-wrap">
                  <div className="duraMaxDiv-con">
                    <div>
                      对不起,您的抽奖<label className="balance">次数不足</label>
                    </div>
                  </div>
                  <div className="duraMaxDiv-btns">
                    <div className="duraMaxDiv-cancel" onClick={this.sureClick}>
                      确定
                    </div>
                    <button className="duraMaxDiv-confirm">
                      获取更多
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/*  抽奖次数用完不可分享给好友弹窗  */}
            {isdegree == 1 && (
              <div className="degreeDiv">
                <div className="degreeDiv-wrap">
                  <div className="degreeDiv-con">
                    <div>
                      对不起,您的抽奖<label className="balance">次数不足</label>
                    </div>
                  </div>
                  <div className="degreeDiv-btns">
                    <div
                      className="degreeDiv-confirm"
                      onClick={this.degreeClick}
                    >
                      确定
                    </div>
                    <div className="degreeDiv-cancel" onClick={this.degreeClick}>
                      取消
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/*  抽中奖品弹窗  */}
            {congratulation == 1 && (
              <div className="Congratulations_sick" onClick={this.shadeClose}>
                <div className="Congratulations_wrap">
                  <div className="Congratulations-con">
                    <img src="http://cdn.jisuapp.cn/static/webapp/images/Congratulations.png" />
                    <label>{prize_title}</label>
                  </div>
                  <div className="Congratulations-btns">
                    {ifWxCoupon ? (
                      <button
                        className="btns Congratulations-confirm"
                        style={convertLineStyleData('margin-left: 62px;')}
                        onClick={this.toAddCard}
                      >
                        立即领取
                      </button>
                    ) : (
                        <button
                          className="btns Congratulations-confirm"
                          style={convertLineStyleData('margin-left: 62px;')}
                          onClick={this.confirmClick}
                        >
                          确定
                      </button>
                      )}
                    <button
                      className="btns Congratulations-share"
                      style={convertLineStyleData('margin-left: 25px;')}
                      onClick={this.shareClickEvent}
                    >
                      传达喜悦
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/*  我的中奖记录弹窗  */}
            {recordSick == 1 && (
              <div className="record_sick" onClick={this.clickRecordSick}>
                <div className="record_wrap" onClick={this.stopPropagation}>
                  <div className="record_header"></div>
                  <div className="record_content">
                    <img
                      className="img_con"
                      style={convertLineStyleData(
                        'display:' + (RecordSickArr == '' ? 'none' : 'block')
                      )}
                      src="http://cdn.jisuapp.cn/static/webapp/images/prize_con.png"
                    />
                    <div className="content_title">
                      <div className="record_line"></div>
                      <label>中奖时间</label>
                      <label>获得奖品</label>
                    </div>
                    <ScrollView
                      scroll-y="true"
                      className="prizeList"
                      hidden={RecordSickArr == ''}
                    >
                      {RecordSickArr.map((item, index) => {
                        return (
                          <div key={index}>
                            <label>{item.add_time}</label>
                            <label>{item.prize_title}</label>
                          </div>
                        )
                      })}
                    </ScrollView>
                    <div className="record_fail" hidden={RecordSickArr != ''}>
                      <img src="http://cdn.jisuapp.cn/static/webapp/images/prize_fail.png" />
                      <div>暂未获得任何奖品哦~</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/*  安慰奖弹窗  */}
            {comfort == 1 && (
              <div className="consolation_sick" onClick={this.shadeClose}>
                <div className="consolation_wrap">
                  <div className="consolation_title">
                    安慰奖<div className="conBefore"></div>
                    <div className="conAfter"></div>
                  </div>
                  <div className="consolation_con">
                    <img src="http://cdn.jisuapp.cn/static/webapp/images/consolation.png" />
                    {ifGetComfort ? (
                      <div className="comfortText">
                        已领取，在微信卡包中查看哦~
                      </div>
                    ) : (
                        <div className="comfortText" className="comfortText">
                          又没中奖，送你一个小礼品
                      </div>
                      )}
                    {!ifWxCoupon && !ifGetComfort && (
                      <div className="comfortText">在优惠券卡包进行查收哦~</div>
                    )}
                  </div>
                  {ifWxCoupon ? (
                    <div className="comfortCouponBtn">
                      <button
                        className="push consolation_share"
                        onClick={this.toAddCard}
                      >
                        立即领取
                      </button>
                      <button
                        className="push consolation_confirm"
                        onClick={this.shadeClose}
                      >
                        确定
                      </button>
                    </div>
                  ) : (
                      <div className="consolation_btns">
                        <button
                          className="push consolation_confirm"
                          onClick={this.comfortClick}
                        >
                          确定
                      </button>
                      </div>
                    )}
                </div>
              </div>
            )}
            {/*  积分兑换弹窗  */}
            {isExchange == 1 && (
              <div className="exchange">
                <div className="exchange-wrap">
                  <div className="exchange-con">
                    <div className="exchangeCan">
                      可兑换次数：<label>{exchangeMessage.exchange_times}</label>
                      <label>次</label>
                    </div>
                    <div className="exchangeLimit">
                      兑换次数：
                      <input
                        type="text"
                        onInput={this.bindReplaceInput}
                        onChange={() => {}}
                        value={inputValue}
                      />
                      <label className="exchangeAll" onClick={this.exchangeAll}>
                        全部兑换
                      </label>
                    </div>
                    <div className="exchangeRule">
                      兑换规则：<label>{exchangeMessage.integral_exchange}</label>
                      分/次
                    </div>
                    <div className="exchangeBalance">
                      积分余额：<label>{exchangeMessage.can_use_integral}</label>
                      分
                    </div>
                  </div>
                  <div className="exchange-btns">
                    <div
                      className="exchange-cancel"
                      onClick={this.exchangeCancel}
                    >
                      取消
                    </div>
                    <div
                      className="exchange-confirm"
                      onClick={this.exchangeConfirm}
                    >
                      确定
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/*  未中奖弹窗  */}
            {prizeFail == 1 && (
              <div className="notwinning_sick">
                <div className="notwinning_wrap">
                  <div className="notwinning_title">
                    未中奖<div className="conBefore"></div>
                    <div className="conAfter"></div>
                  </div>
                  <div className="notwinning_con">
                    <img src="http://cdn.jisuapp.cn/static/webapp/images/notWinning.png" />
                    <div>很遗憾！</div>
                    <div>您什么都没抽中哦~</div>
                  </div>
                  <div className="notwinning_btns">
                    <button
                      className="push notwinning_confirm"
                      onClick={this.notwinningClick}
                    >
                      确定
                    </button>
                    {/*  <button class="push notwinning_share" style={convertLineStyleData('margin-left: 36rpx;')} data-type="share" open-type="share">分享给好友    </button>  */}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/lucky-wheel-detail/LuckyWheelDetail.jsx